export const TemplateCategories = Object.freeze({
	MARKETING: 'MARKETING',
	UTILITY: 'UTILITY',
	AUTHENTICATION: 'AUTHENTICATION',
});

export const TemplateTypes = Object.freeze({
	MULTI_PRODUCT: 'MULTI-PRODUCT',
	CATALOG: 'CATALOG',
	CUSTOM: 'CUSTOM',
	LTO: 'LTO',
});

export const TemplateHeaderFormats = Object.freeze({
	TEXT: 'TEXT',
	IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
    DOCUMENT: 'DOCUMENT',
    LOCATION: 'LOCATION',
});

export const TemplateButtons = Object.freeze({
	CATALOG: 'CATALOG',
	MPM: 'MPM',
	URL: 'URL',
});

export const TemplateMetaStatuses = Object.freeze({
	pending: 'PENDING',
	rejected: 'REJECTED',
	approved: 'APPROVED',
	flagged: 'FLAGGED',
	paused: 'PAUSED',
	pending_deletion: 'PENDING_DELETION',
});

export const TemplateComponentType = Object.freeze({
	HEADER: 'HEADER',
	BODY: 'BODY',
	FOOTER: 'FOOTER',
	BUTTONS: 'BUTTONS',
	LIMITED_TIME_OFFER: 'LIMITED_TIME_OFFER',
});
